import { useEffect, useRef, useState } from 'react';

import clsx from 'clsx';
import { FaForward, FaPause, FaPlay } from 'react-icons/fa6';
import Texts from 'react-sdk/Texts';
import classes from './CanvasCharacter.module.css';
import SoundPlayer from 'react-sdk/SoundPlayer';

// si char_id et pas sequence_element : on affiche un perso en neutre (éventuellement loop de qqs attitudes)
// si char_id + sequence_element :
//   * si c'est le perso principal, on l'affiche, on le fait parler, on affiche le dial
//   * si c'est un perso secondaire (dans sequence_element.otherCharacters), on l'affiche en neutre
const VISIBLE = "VISIBLE"
const INACTIVE = "INACTIVE"
const HIDDEN = "HIDDEN"

const CanvasCharacter = ({char_id, dial, attitude="idle", loading, onEnd}) => {

  const charRef = useRef(null)
  const canvasRef = useRef(null)

  const [visibility, setVisibility] = useState(VISIBLE);
  const [charType, setCharType] = useState(null);


  useEffect(() => {
    charRef.current = window.SpeechAPI.createCanvasCharacter(char_id, canvasRef.current)

    let chartype = charRef.current?.charRenderer?.__class__.__name__

    if(chartype ===  'canvas.BasisCanvasRenderer') {
      setCharType("BASIS")
    }
    else {
      setCharType("ANIMATE")
    }

    return () => {
      charRef.current.stop()
      charRef.current.delete()
      charRef.current = null
    }
  }, []);


  function loopIdle() {
    charRef.current.playContent("", "", attitude, "",() => {
      loopIdle()
    })
  }

  /* à chaque changement de sequence_element */
  useEffect(() => {
    if(!charRef.current) return
    if(loading) return

    if(char_id && !dial) {
      charRef.current.enableBackToNeutral(false)

      loopIdle()
    }

    if(char_id && dial) {

      dial.charRef = charRef

      // const {Text, TextTimings, AttitudeTimings, Audio, Character, otherCharacters} = dial.element.raw
      // const dialText = dial.element.line.get("Text")

      const Text = dial.element.line.get("Text")
      const TextTimings = dial.element.line.get("TextTimings")
      const AttitudeTimings = dial.element.line.get("AttitudeTimings")
      const Audio = dial.element.line.get("Audio")
      const Character = dial.element.line.get("Character")
      const otherCharacters = dial.element.line.get("otherCharacters")



      setVisibility(VISIBLE)


      if(Character === char_id) {
        charRef.current.unfreeze()
        if(dial.element.Type === "choice_title"){
          charRef.current.setTextCallback(subtitle => dial.subtitle = null)
          // NOTE ne pas faire de playContent ici car ca va lire cet élément qui n'est pas un dial, et comme il n'a pas de durée la speechilb lui donne une durée par défaut qui fait un next plus tard au mauvais moment dans le dialogue suivant
        }
        else {
          charRef.current.setTextCallback(subtitle => dial.subtitle = subtitle)
          charRef.current.playContent(Text, TextTimings, AttitudeTimings, Audio || "", () => {
            if(Audio) {
              dial.subtitle = null

              if(onEnd) onEnd();
            }
          })
        }

      }
      else if(otherCharacters && otherCharacters.includes(char_id)) {
        charRef.current.unfreeze()
        setVisibility(INACTIVE)
        charRef.current.playContent("", "", "idle", "",() => {})
      }
      else {
        // freeze/unfreeze
        charRef.current.freeze()
        setVisibility(HIDDEN)
      }
    }

  }, [char_id, dial, loading]);
  return (
    <div className={clsx(classes.Character, "Character", char_id, classes[visibility], charType)}>
      <div className={clsx(classes.CharacterCanvas, "CharacterCanvas")}>
        <div className={classes.canvas_wrapper}><canvas ref={canvasRef} key={char_id} className={classes.canvas}></canvas></div>
      </div>
    </div>
  );
};

export default CanvasCharacter;